import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ClaveUnicaService } from '../../services/claveunica.service';

@Component({
  selector: 'app-claveunica-logout',
  standalone: true,
  imports: [],
  templateUrl: './claveunica-logout.component.html',
  styleUrl: './claveunica-logout.component.css',
})
export class ClaveUnicaLogoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly claveUnicaService = inject(ClaveUnicaService);
  private readonly titleService = inject(Title);

  async ngOnInit() {
    // Cambiar el título de la página
    this.titleService.setTitle('ClaveÚnica - Cerrando sesión');

    console.warn(
      '[DEBUG] Componente logout cargado después de cerrar sesión en ClaveÚnica',
    );

    const url = sessionStorage.getItem('claveunica_url_retorno');

    if (url) {
      console.warn('[DEBUG] Redirigiendo a URL de destino:', url);

      // Limpiar el sessionStorage
      sessionStorage.removeItem('claveunica_url_retorno');

      // Redirigir a la URL final
      window.location.href = url;
    } else {
      console.warn('[DEBUG] No se encontró URL de redirección, yendo a error');
      this.router.navigate(['/claveunica/error']);
    }
  }

  onBackToHome() {
    this.router.navigate(['/claveunica/error']);
  }
}
